import TooltipTrigger from './TooltipTrigger.component';

export default TooltipTrigger;
